module.exports = __webpack_public_path__ + "a6962864.png";